import React, { useState, useEffect } from "react";
import "./index.css";
import OverviewChart from "../../components/OverviewChart";
import {
  getContentTrendsData,
  getOverview,
  getTeamLocationForFilter,
  getUserDetailsOverview,
} from "../../actions/assessment";
import { GrDownload } from "react-icons/gr";
import { IoMdTrendingUp } from "react-icons/io";
import { IoMdTrendingDown } from "react-icons/io";
import { CiCircleInfo } from "react-icons/ci";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Cell,
  ResponsiveContainer,
} from "recharts";
import { Template } from "./template";
import { useInView } from "react-intersection-observer";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

import { useLoadingSelector, useUserTokenSelector } from "store/reducers";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "store/actions";
import { useLocation } from "react-router-dom";
import { getB2BMoodData, getMoodScoreData } from "actions/dataLoad";
import { getTeamLocation } from "actions/auth";
const obj = {
  totalScore: 0,
  moodScoreChartData: [
    { name: "Jan", uv: 0 },
    { name: "Feb", uv: 0 },
    { name: "Mar", uv: 0 },
    { name: "Apr", uv: 0 },
    { name: "May", uv: 0 },
    { name: "Jun", uv: 0 },
    { name: "Jul", uv: 0 },
    { name: "Aug", uv: 0 },
    { name: "Sep", uv: 0 },
    { name: "Oct", uv: 0 },
    { name: "Nov", uv: 0 },
    { name: "Dec", uv: 0 },
  ],
};

export const Overview = ({ history, adminCorporateId }) => {
  const userToken = useUserTokenSelector();
  const [overviewItems, setOverviewItems] = useState([]);
  const [selectedYear, setSelectedYear] = useState("All Time");
  const [selectTimeRange, setSelectTimeRange] = useState("all");
  const [checkData, setCheckData] = useState(0);
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [selectedLocation, setSelectedLocation] = useState("All Locations");
  const [selectedTeam, setSelectedTeam] = useState("All Teams");
  // const [selectTimeRange, setSelectTimeRange] = useState("all");
  // const [checkData, setCheckData] = useState(0);
  // const [selectedMonth, setSelectedMonth] = useState("All");
  // const [selectedLocation, setSelectedLocation] = useState("");
  // const [selectedTeam, setSelectedTeam] = useState("");
  const [isPainActive, setIsPainActive] = useState(false);
  const [isContentActive, setIsContentActive] = useState(false);
  const [error, setError] = useState(""); // Define error state
  const [open, setOpen] = useState(false); // Define open state for potential error display
  const [isTypeActive, setIsTypeActive] = useState(false);
  const [isTimeActive, setIsTimeActive] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const [showCustomCalendar, setShowCustomCalendar] = useState(false);
  const [customDateRange, setCustomDateRange] = useState(null);

  const monthNames = [
    "All",
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const yearsArray = ["All Time", "2023", "2024"];
  const [teamArray, setTeamArray] = useState(["All Teams"]);
  const [locationArray, setLocationArray] = useState(["All Locations"]);
  const timeRangeArray = [
    "Today",
    "This Week",
    "This Month",
    "Last 3 months",
    "Last 6 months",
    "Last Year",
    "All Time",
    "Custom",
  ];
  const [groupedTeamLocations, setGroupedTeamLocations] = useState({});
  const [moodRes, setMoodRes] = useState(null); // For loadMoodScoreData
  const [moodScoreChartData, setMoodScoreChartData] = useState(
    obj.moodScoreChartData
  ); // For loadMoodScoreData
  const [totalMoodScore, setTotalMoodScore] = useState(obj.totalScore); // For loadMoodScoreData
  const [years, setYears] = useState(["2024"]);
  const dispatch = useDispatch();
  const isLoading = useLoadingSelector();
  const [selectedGender, setSelectedGender] = useState("Overall");
  const [teams, setTeams] = useState([]);
  const [locations, setLocations] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("All Teams");
  const location = useLocation();
  const [isDownloading, setIsDownloading] = useState(false);
  

  const [userInfo, setUserInfo] = useState({
    signups: {
      total: 0,
      previous: 0,
    },
    active: {
      total: 0,
      previous: 0,
    },
    logins: {
      total: 0,
      previous: 0,
    },
  });
  const [contentTrends, setContentTrends] = useState([
    {
      name: "Sleep",
      value: 45,
    },
    {
      name: "Yoga",
      value: 30,
    },
    {
      name: "Meditation",
      value: 20,
    },
  ]);
  const [distribution, setDistribution] = useState([
    {
      name: "Morning 6am-12pm",
      value: 45,
    },
    {
      name: "Afternoon 12pm-6pm",
      value: 45,
    },
    {
      name: "Evening 6pm-12am",
      value: 30,
    },
    {
      name: "Night 12am-6am",
      value: 70,
    },
  ]);
  const [engagedEmp, setEngagedEmp] = useState([
    {
      name: "Sakshi",
      team: "Marketing",
    },
    {
      name: "Lawrance",
      team: "Product",
    },
    {
      name: "Swara",
      team: "Design",
    },
    {
      name: "Amit",
      team: "Product",
    },
    {
      name: "Dristhi",
      team: "Design",
    },
  ]);
  const [engagement, setEngagement] = useState([]);

  function handleYearChange(event) {
    const selectedYear = event.target.value;
    setSelectedYear(selectedYear);
  }
  function mhandleYearChange(event) {
    const mPointYear = event.target.value;
    setMPointYear(mPointYear);
  }

  const timeRangeMap = new Map([
    ["Today", "today"],
    ["This Week", "7d"],
    ["This Month", "30d"],
    ["Last 3 months", "3m"],
    ["Last 6 months", "6m"],
    ["Last Year", "1y"],
    ["All Time", "all"],
    ["Custom", "custom"],
  ]);

  function mapTimeRangeToApiValue(timeRange) {
    return timeRangeMap.get(timeRange) || "all";
  }

  const showError = (text) => {
    setError(text);
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      setOpen(false);
    }
    setOpen(false);
  };

  const handleTimeRangeChange = (e) => {
    const value = e.target.value;
    setSelectTimeRange(value);
    if (value === "custom") {
      setShowCustomCalendar(true);
    } else {
      setShowCustomCalendar(false);
    }
  };

  const handleCustomDateChange = (date) => {
    if (Array.isArray(date)) {
      const [startDate, endDate] = date;
      setCustomDateRange([startDate, endDate]);
      if (startDate && endDate) {
        setShowCustomCalendar(false);
      }
      return;
    }
    setCustomDateRange(date);
  };

  // Handler for Team dropdown change
  const handleTeamChange = (e) => {
    const newTeam = e.target.value;
    setSelectedTeam(newTeam);
    // When team changes, reset location to "All Locations" for that team's context.
    // The useEffect below will then update locationArray based on newTeam.
    setSelectedLocation("All Locations");
  };

  // Handler for Location dropdown change
  const handleLocationChange = (e) => {
    const newLocation = e.target.value;
    setSelectedLocation(newLocation);

    // If the team filter is currently "All Teams", try to infer the specific team
    if (selectedTeam === "All Teams") {
      if (newLocation === "All Locations") {
        // If location is also "All Locations", keep team as "All Teams"
        setSelectedTeam("All Teams");
      } else {
        // Find the team that contains this specific location
        let inferredTeam = "All Teams"; // Default if not found
        for (const teamName in groupedTeamLocations) {
          if (groupedTeamLocations[teamName].includes(newLocation)) {
            inferredTeam = teamName;
            break; // Found the first matching team
          }
        }
        setSelectedTeam(inferredTeam);
      }
    }
    // If selectedTeam is already specific, changing location within that team's options
    // doesn't require changing selectedTeam, as the team filter is already applied.
  };

  useEffect(() => {
    getTeamLocationFilter();
  }, []);

  const getCustomDates = () => {
    if (Array.isArray(customDateRange)) {
      const [startDate, endDate] = customDateRange;
      return { startDate, endDate, singleDate: startDate };
    }
    return { startDate: null, endDate: null, singleDate: customDateRange };
  };

  useEffect(() => {
    const { startDate, endDate } = getCustomDates();
    const isCustomDateValid =
      selectTimeRange !== "custom" || (startDate && endDate);

    if (!isCustomDateValid) return;

    // Call all APIs
    getContentTrend();
    getUserOverviewData();
    getOverviewData();
    // loadAllData();
    // getAllB2BMoodData();
  }, [selectTimeRange, customDateRange, selectedTeam, selectedLocation, userToken]);
  
  const loadAllData = async () => {
    dispatch(startLoading());
    await getAllB2BMoodData();
    dispatch(stopLoading());
  };

  useEffect(() => {
    // Update location options when selectedTeam changes
    if (selectedTeam === "All Teams") {
      const allUniqueLocations = [
        "All Locations",
        ...new Set(Object.values(groupedTeamLocations).flat()),
      ].sort();
      setLocationArray(allUniqueLocations);
    } else if (groupedTeamLocations[selectedTeam]) {
      setLocationArray(
        ["All Locations", ...groupedTeamLocations[selectedTeam]].sort()
      );
    } else {
      setLocationArray(["All Locations"]);
    }
    setSelectedLocation("All Locations"); // Reset location to "All Locations" when team changes
  }, [selectedTeam, groupedTeamLocations]);

  const getUserOverviewData = async () => {
    try {
      dispatch(startLoading());
      const timeRange = selectTimeRange;
      const teamType = selectedTeam === "All Teams" ? "all" : selectedTeam;
      const location =
        selectedLocation === "All Locations" ? "all" : selectedLocation;
      const { startDate, endDate } = getCustomDates();
      const customDate =
        selectTimeRange === "custom" ? [startDate, endDate] : null;
      const res = await getUserDetailsOverview(
        userToken,
        adminCorporateId,
        timeRange,
        location,
        teamType,
        customDate
      );
      const overviewData = res.data.data;

      setUserInfo({
        signups: {
          total: overviewData.activeSignups || 0, // Assuming activeSignups is the total signups
          previous: 0, // API doesn't provide previous month data for signups
        },
        active: {
          total: overviewData.activeUserCount || 0,
          previous: 0, // API doesn't provide previous month data for active users
        },
        // Logins are not directly available in the new response,
        // you might need to calculate this or adjust if it's available elsewhere
        logins: {
          total:
            overviewData.userDetails?.reduce(
              (sum, user) => sum + user.userOpenAppCount,
              0
            ) || 0,
          previous: 0,
        },
      });

      // Extracting ged employees (top 5 by userOpenAppCount as an example)
      const sortedUsers = [...(overviewData.userDetails || [])].sort(
        (a, b) => b.userOpenAppCount - a.userOpenAppCount
      );
      // setEngagedEmp(
      //   sortedUsers.slice(0, 5).map((detail) => ({
      //     name: detail.user.fullName,
      //     team: detail.user.teamName || "N/A",
      //   }))
      // );
      setDistribution([
        {
          name: "Morning 6am-12pm",
          value: overviewData.userCountOpenApp?.morning || 0,
        },
        {
          name: "Afternoon 12pm-6pm",
          value: overviewData.userCountOpenApp?.noon || 0,
        },
        {
          name: "Evening 6pm-12am",
          value: overviewData.userCountOpenApp?.evening || 0,
        },
        {
          name: "Night 12am-6am",
          value: overviewData.userCountOpenApp?.night || 0,
        },
      ]);

      const engagementData = [
        {
          name: "Therapy",
          value: overviewData.engagement?.therapy || 0,
        },
        {
          name: "Challenge",
          value: overviewData.engagement?.challenge || 0,
        },
        {
          name: "Planner",
          value: overviewData.engagement?.planner || 0,
        },
      ];
      setEngagement(engagementData);

      // For "Major Pain Points" (overviewItems), the API response structure is different.
      // You'll need to decide how to map `overviewData.userDetails` to `overviewItems`
      // For now, let's assume it's the raw userDetails or needs further processing.

      dispatch(stopLoading());
    } catch (error) {
      dispatch(stopLoading());
      console.log(error);
    }
  };

  const getContentTrend = async () => {
    try {
      const apiTimeRange = mapTimeRangeToApiValue(selectTimeRange);
      // Assuming 'all' for teamType and location if not specifically selected for this chart
      // or if you have specific filters for content trends, use them here.
      const apiTeamType = selectedTeam === "All Teams" ? "all" : selectedTeam;
      const apiLocation =
        selectedLocation === "All Locations" ? "all" : selectedLocation;
      const { startDate, endDate } = getCustomDates();
      const customDate =
        selectTimeRange === "custom" ? [startDate, endDate] : null;

      const res = await getContentTrendsData(
        userToken,
        apiTimeRange,
        apiLocation, // Or a specific location filter for content trends
        apiTeamType,
        customDate
      );

      if (res && res.data && res.data.data) {
        // Assuming the API returns data in a format like:
        // { status: "success", data: [{ videoCategory: "Sleep", uniqueUserCount: 45 }, ...] }
        // Transform it to the format your chart expects:
        // [{ name: "Sleep", value: 45 }, ...]
        const formattedTrends = res.data.data.map((item) => ({
          name: item.videoCategory,
          value: item.uniqueUserCount,
        }));
        setContentTrends(formattedTrends);
      } else {
        // Handle cases where data might not be in the expected format or is empty
        setContentTrends([]); // Set to empty or a default state
        console.warn(
          "No content trends data received or data is in an unexpected format."
        );
      }
      dispatch(stopLoading());
    } catch (error) {
      dispatch(stopLoading());
      console.error("Failed to load content trends:", error);
      // Optionally, set an error state to display to the user
      // showError("Failed to load content trends."); // If you have an error display mechanism
    }
  };

  const getOverviewData = async () => {
    try {
      // to handle a custom date range instead of a predefined string.
      let timeRangeParam = selectTimeRange;
      const apiTimeRange = mapTimeRangeToApiValue(selectTimeRange);
      // Assuming 'all' for teamType and location if not specifically selected for this chart
      // or if you have specific filters for content trends, use them here.
      const apiTeamType = selectedTeam === "All Teams" ? "all" : selectedTeam;
      const apiLocation =
        selectedLocation === "All Locations" ? "all" : selectedLocation;
      dispatch(startLoading());

      const { startDate, endDate } = getCustomDates();
      const res = await getOverview(
        userToken,
        adminCorporateId,
        timeRangeParam,
        selectTimeRange === "custom" ? [startDate, endDate] : null,
        apiTeamType,
        apiLocation
      );
      setCheckData(res.data.result.length);
      setOverviewItems(res.data.result);
      dispatch(stopLoading());
    } catch (error) {
      dispatch(stopLoading());
      console.log(error);
    }
  };

  const getAllB2BMoodData = async () => {
    try {
      dispatch(startLoading());
      const res = await getB2BMoodData(
        userToken,
        adminCorporateId,
        selectTimeRange,
        selectedTeam,
        selectedLocation
      );
      setMoodRadarChartDate(res.data.moodChartData);
      dispatch(stopLoading());
    } catch (err) {
      dispatch(stopLoading());
      if (err?.response?.data?.redirectToSignIn) {
        showError(err.response?.data?.error || "Something went wrong!");
        setTimeout(
          () =>
            history.push({
              pathname: "/signin",
              state: { referer: location.pathname },
            }),
          3000
        );
      } else {
        showError(err?.response?.data?.error || "Failed to load mood data.");
      }
    }
  };

  const loadMoodScoreData = async () => {
    try {
      const res = await getMoodScoreData(
        userToken,
        adminCorporateId,
        selectedTeam,
        selectedLocation,
        selectedGender,
        selectTimeRange
      );
      const yearsData = res.data.yearsArray;
      const years = yearsData.map((year) => year);
      years.sort((a, b) => b - a);
      setYears(years.length > 0 ? years : [currentYear]);
      // const teamsData = teamArray;
      // const teams = teamsData.map((team) => team);
      // teams.push("All Teams");
      // setTeams(teams);
      // const locationsData = locationArray;
      // const locations = locationsData.map((location) => location);
      // locations.push("All Locations");
      // setLocations(locations);
      setMoodRes(res.data.moodData);
      setMoodScoreChartData(
        res.data?.moodData[selectedYear]?.moodScoreChartData ||
          obj.moodScoreChartData
      );
      setTotalMoodScore(
        res.data?.moodData[selectedYear]?.totalScore || obj.totalScore
      );
    } catch (err) {
      dispatch(stopLoading());
      if (err.response.data.redirectToSignIn) {
        showError(err.response.data.error);
        setTimeout(
          () =>
            history.push({
              pathname: "/signin",
              state: { referer: location.pathname },
            }),
          3000
        );
      } else {
        showError(
          err?.response?.data?.error || "Failed to load mood score data."
        );
      }
    }
  };

  const getTeamLocationFilter = async () => {
    dispatch(startLoading());
    try {
      const res = await getTeamLocationForFilter(userToken);
      if (res && res.data && Array.isArray(res.data.teamLocations)) {
        const fetchedTeams = new Set();
        const fetchedLocations = new Set();
        const groupedData = {};
        res.data.teamLocations.forEach((item) => {
          if (item.teamName) fetchedTeams.add(item.teamName);
          if (item.location) fetchedLocations.add(item.location);
          if (item.teamName) {
            fetchedTeams.add(item.teamName);
            if (!groupedData[item.teamName]) {
              groupedData[item.teamName] = [];
            }
          }
          if (item.location) {
            fetchedLocations.add(item.location);
            if (
              item.teamName &&
              item.location &&
              !groupedData[item.teamName].includes(item.location)
            ) {
              groupedData[item.teamName].push(item.location);
            }
          }
        });

        const sortedTeams = Array.from(fetchedTeams).sort();
        const sortedLocations = Array.from(fetchedLocations).sort();

        setTeamArray(["All Teams", ...sortedTeams]);
        setLocationArray(["All Locations", ...sortedLocations]); // Initial full list
        setGroupedTeamLocations(groupedData);
        dispatch(stopLoading());
      } else {
        console.warn(
          "Team/Location data not in expected format or teamLocations is not an array. Response:",
          res
        );
        setTeamArray(["All Teams"]); // Default value
        setLocationArray(["All Locations"]); // Default value
      }
    } catch (error) {
      console.error("Error fetching team/location filters:", error);
      setTeamArray(["All Teams"]); // Reset to default on error
      setLocationArray(["All Locations"]); // Reset to default on error
      // Optionally, display an error to the user: showError("Failed to load team/location filters.");
    }
  };

  const colors = ["#49AF7C", "#89D4AF", "#C4EED9"];

  const [painRef, painInView] = useInView({
    threshold: 0.5,
  });
  const [contentRef, contentInView] = useInView({
    threshold: 0.7,
  });
  const [typeRef, typeInView] = useInView({
    threshold: 0.7,
  });
  const [timeRef, timeInView] = useInView({
    threshold: 0.7,
  });
  useEffect(() => {
    if (painInView) {
      setIsPainActive(true);
    }
  }, [painInView]);

  useEffect(() => {
    if (contentInView) {
      setIsContentActive(true);
    }
  }, [contentInView]);

  useEffect(() => {
    if (typeInView) {
      setIsTypeActive(true);
    }
  }, [typeInView]);

  useEffect(() => {
    if (timeInView) {
      setIsTimeActive(true);
    }
  }, [timeInView]);

  const reportData = () => {
    const dataJson = {
      signups: userInfo.signups,
      active: userInfo.active,
      logins: userInfo.logins,
      overviewItems: overviewItems,
      contentTrends: contentTrends,
      engagement: engagement,
      distribution: distribution,
      engagedEmp: engagedEmp,
    };
    return dataJson;
  };

  const handleShowReport = () => {
    setIsDownloading(true);
    setShowReport(true);
    dispatch(startLoading());
  };

  const handleReportClose = () => {
    setIsDownloading(false);
    setShowReport(false);
    dispatch(stopLoading());
  };
  return (
    <div className="overview">
    {showCustomCalendar && (
        <div
          className="overview-overlay-background"
          onClick={() => setShowCustomCalendar(false)}
          aria-label="Close calendar"
        ></div>
      )}
      {isLoading ? (
        <></>
      ) : (
        <>
          <div>
            <div className="overview-top">
              {/* Global Filters */}
              <div className="overview-filter">
                {/* <label htmlFor="timeRangeFilter">Time Range:</label> */}
                <select
                  id="timeRangeFilter"
                  data-testid="timeRangeFilter"
                  value={selectTimeRange}
                  aria-label="Time Range"
                  // onChange={(e) => setSelectTimeRange(e.target.value)}
                  onChange={handleTimeRangeChange}
                >
                  {timeRangeArray.map((time) => (
                    <option key={time} value={mapTimeRangeToApiValue(time)}>
                      {time}
                    </option>
                  ))}
                </select>
              </div>
              <div className="overview-filter">
                {/* <label htmlFor="teamFilter">Team:</label> */}
                <select
                  id="teamFilter"
                  data-testid="teamFilter"
                  value={selectedTeam}
                  aria-label="Team" // Use the new handler
                  onChange={handleTeamChange}
                >
                  {teamArray.map((team) => (
                    <option key={team} value={team}>
                      {team}
                    </option>
                  ))}
                </select>
              </div>
              <div className="overview-filter">
                {/* <label htmlFor="locationFilter">Location:</label> */}
                <select
                  id="locationFilter"
                  data-testid="locationFilter"
                  value={selectedLocation}
                  aria-label="Location" // Use the new handler
                  onChange={handleLocationChange}
                >
                  {locationArray.map((location) => (
                    <option key={location} value={location}>
                      {location}
                    </option>
                  ))}
                </select>
              </div>

              {/* Filters for other charts (e.g., Mood Score) */}
              {/* {selectedYear !== "All Time" && (
                <div className="overview-filter">
                  <select
                    value={selectedMonth}
                    aria-label="Month"
                    onChange={(e) => setSelectedMonth(e.target.value)}
                  >
                    {monthNames.map((month) => (
                      <option key={month} value={month}>
                        {month}
                      </option>
                    ))}
                  </select>
                </div>
              )} */}
              {showCustomCalendar && (
                <div className="custom-calendar-container">
                  <Calendar
                    onChange={handleCustomDateChange}
                    value={customDateRange}
                    selectRange
                  />
                </div>
              )}

              <div className={`download-div  ${isDownloading ? "disabled" : ""}`} onClick={!isDownloading ? handleShowReport : null}>
                <GrDownload />
                <span>Download</span>
              </div>
            </div>
            <div id="overview" className="hr-overviewScreen">
              <div className="info-divs">
                <div className="info-div">
                  <div className="info-top">
                    <span data-testid="Signups">Signups</span>
                    <CiCircleInfo className="overview-infoIcon" />
                  </div>
                  <div className="info-bottom">
                    {userInfo.signups.total ? (
                      <p className="info-data" data-testid="signup-count">
                        {userInfo.signups.total}
                      </p>
                    ) : (
                      <p className="info-data" data-testid="signup-count">
                        0
                      </p>
                    )}
                  </div>
                </div>
                <div className="info-div">
                  <div className="info-top">
                    <span>Active Users</span>
                    <CiCircleInfo className="overview-infoIcon" />
                  </div>
                  <div className="info-bottom">
                    {userInfo.active.total ? (
                      <p className="info-data" data-testid="active-user-count">
                        {userInfo.active.total}
                      </p>
                    ) : (
                      <p className="info-data" data-testid="active-user-count">
                        0
                      </p>
                    )}
                  </div>
                </div>
                <div className="info-div">
                  <div className="info-top">
                    <span>Number of Logins</span>
                    <CiCircleInfo className="overview-infoIcon" />
                  </div>
                  <div className="info-bottom">
                    {userInfo.logins.total ? (
                      <p className="info-data" data-testid="login-count">
                        {userInfo.logins.total}
                      </p>
                    ) : (
                      <p className="info-data" data-testid="login-count">
                        0
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="painpoint-div">
                <div className="painpoint-top">
                  <p>Major Pain Points</p>
                  <div className="painpoint-tleft">
                    <CiCircleInfo className="overview-infoIcon" />
                  </div>
                </div>
                <div className="overview-graph" ref={painRef}>
                  {checkData === 0 ? (
                    <h3 style={{ margin: "0px auto" }}>No Data Found</h3>
                  ) : (
                    isPainActive && <OverviewChart items={overviewItems} />
                  )}
                </div>
              </div>
              <div className="info-divs">
                <div className="info-div graph">
                  <div className="info-top">
                    <span>Content Trends</span>
                    <CiCircleInfo className="overview-infoIcon" />
                  </div>
                  <div
                    style={{ width: "100%", height: "300px" }}
                    ref={contentRef}
                  >
                    <ResponsiveContainer width="100%" height={300}>
                      <BarChart
                        data={contentTrends}
                        margin={{ top: 0, right: 5, bottom: 5, left: -25 }}
                      >
                        <CartesianGrid
                          strokeDasharray="3 3"
                          horizontal={true}
                          vertical={false}
                        />
                        <XAxis dataKey="name" tickLine={false} />
                        <YAxis tickLine={false} />
                        {isContentActive && (
                          <Bar dataKey="value" name="Value" barSize={50}>
                            {contentTrends.map((entry, index) => (
                              <Cell
                                key={`cell-${index}`}
                                fill={colors[index % colors.length]}
                              />
                            ))}
                          </Bar>
                        )}
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
                <div className="info-div graph">
                  <div className="info-top">
                    <span>Engagement by type</span>
                    <CiCircleInfo className="overview-infoIcon" />
                  </div>
                  <div style={{ width: "100%", height: "300px" }} ref={typeRef}>
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart
                        data={engagement}
                        layout="vertical"
                        barSize={40}
                        margin={{ top: 0, right: 5, bottom: 5, left: 5 }}
                      >
                        <CartesianGrid
                          strokeDasharray="3 3"
                          horizontal={false}
                          vertical={true}
                        />
                        <XAxis type="number" tickLine={false} />
                        <YAxis
                          dataKey="name"
                          type="category"
                          tickLine={false}
                        />
                        {isTypeActive && (
                          <Bar dataKey="value" name="Value">
                            {engagement.map((entry, index) => (
                              <Cell
                                key={`cell-${index}`}
                                fill={colors[index % colors.length]}
                              />
                            ))}
                          </Bar>
                        )}
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
                <div
                  style={{
                    // width: "100%",
                    boxShadow: "2px 1px 8px 3px #d4d4d4",
                    border: "0px",
                    flex:'1',
                    // maxWidth: "1266px",
                    padding: "10px 20px",
                    borderRadius: "30px",
                  }}
                >
                  <div className="info-top">
                    <span>Time Distribution of app usage</span>
                    <CiCircleInfo className="overview-infoIcon" />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      height: "300px",
                      marginTop: "30px",
                    }}
                    ref={timeRef}
                  >
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart
                        data={distribution}
                        layout="vertical"
                        margin={{ left: 20 }}
                        barSize={40}
                      >
                        <CartesianGrid
                          strokeDasharray="3 3"
                          horizontal={false}
                          vertical={true}
                        />
                        <XAxis type="number" />
                        <YAxis dataKey="name" type="category" />
                        {isTimeActive && (
                          <Bar dataKey="value" name="Value">
                            {distribution.map((entry, index) => (
                              <Cell
                                key={`cell-${index}`}
                                fill={colors[index % colors.length]}
                              />
                            ))}
                          </Bar>
                        )}
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {showReport && <Template data={reportData()} close={handleReportClose} />}
    </div>
  );
};

export default Overview;
